import React from 'react';
import { ButtonStyled } from './Button.styled';

const Button = ({
  handleSubmit = () => {},
  title = '',
  type,
  name,
  disabled = false,
}) => {
  return (
    <ButtonStyled
      disabled={disabled}
      type={type}
      name={name}
      onClick={handleSubmit}
    >
      {title}
    </ButtonStyled>
  );
};

export default Button;
